import React from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useGoogleMapsLoader } from "app/utils/hooks/useGoogleMapsLoader";
import { useAppSelector } from "setup/redux/Hooks";
import { Languages, MAP_LIBRARY, REACT_APP_MAP_KEY_API } from "app/utils/common/constants";
import { selectLanguage } from "app/modules/auth";

type Props = {
  lat: number;
  lng: number;
};

const MapMarker: React.FC<Props> = ({ lat, lng }) => {
  const language = useAppSelector(selectLanguage);
  const rtlMode = language === Languages.ar;
  // const { isLoaded } = useJsApiLoader({
  //   googleMapsApiKey: (REACT_APP_MAP_KEY_API || ""),
  //   language: rtlMode ? "ar" : "en",
  //   libraries: MAP_LIBRARY,
  // });

  if (!window.google) return <div style={{ height: 200 }}>Loading...</div>;

  return (
    <GoogleMap
      mapContainerStyle={{
        width: "100%",
        height: "200px",
        borderRadius: "5px",
      }}
      center={{ lat, lng }}
      zoom={15}
      options={{
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false,
      }}
    >
      <Marker position={{ lat, lng }} />
    </GoogleMap>
  );
};

export default MapMarker;